import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type Branding } from '../api/client';

const BRANDING_KEY = ['branding'] as const;

export function useBranding() {
  return useQuery<Branding>({
    queryKey: BRANDING_KEY,
    queryFn: () => api.branding.get(),
  });
}

export function useUpdateBranding() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<Omit<Branding, 'hostId'>>) => api.branding.update(data),
    onSuccess: (updatedBranding) => {
      queryClient.setQueryData(BRANDING_KEY, updatedBranding);
    },
  });
}
